import React from 'react'
import { Link } from 'react-router-dom'

const BrandStory = () => {
    return (
        <section className="brand-story py-80 bg-gradient-to-br from-neutral-50 to-main-50 position-relative overflow-hidden mb-40">
            {/* Background Pattern */}
            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 0 }}>
                <div className="position-absolute" style={{
                    top: '10%',
                    left: '5%',
                    width: '120px',
                    height: '120px',
                    background: 'linear-gradient(135deg, rgba(41, 158, 96, 0.1) 0%, rgba(41, 158, 96, 0.05) 100%)',
                    borderRadius: '50%',
                    transform: 'rotate(45deg)'
                }}></div>
                <div className="position-absolute" style={{
                    top: '60%',
                    right: '8%',
                    width: '80px',
                    height: '80px',
                    background: 'linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 193, 7, 0.05) 100%)',
                    borderRadius: '50%',
                    transform: 'rotate(-30deg)'
                }}></div>
                <div className="position-absolute" style={{
                    bottom: '20%',
                    left: '15%',
                    width: '60px',
                    height: '60px',
                    background: 'linear-gradient(135deg, rgba(41, 158, 96, 0.08) 0%, rgba(41, 158, 96, 0.03) 100%)',
                    borderRadius: '50%',
                    transform: 'rotate(60deg)'
                }}></div>
            </div>

            <div className="container container-lg position-relative" style={{ zIndex: 1 }}>
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-8">
                        <div className="brand-story__content text-center">
                            {/* Icon or Logo */}
                            <div className="mb-40">
                                <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white shadow-lg mb-24" 
                                     style={{ 
                                         width: 'clamp(80px, 12vw, 120px)', 
                                         height: 'clamp(80px, 12vw, 120px)',
                                         border: '3px solid var(--main-600)'
                                     }}>
                                    <i className="ph-fill ph-heart text-main-600" style={{ fontSize: 'clamp(32px, 6vw, 48px)' }}></i>
                                </div>
                            </div>

                            {/* Heading */}
                            <h2 className="mb-32" style={{ 
                                fontSize: 'clamp(28px, 6vw, 48px)', 
                                lineHeight: '1.2',
                                fontWeight: '700',
                                background: 'linear-gradient(135deg, #1a1a1a 0%, #299E60 100%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text'
                            }}>
                                Gelenekten Gelen <br />
                                <span className="text-main-600">Lezzet Hikayemiz</span>
                            </h2>

                            {/* Story Content */}
                            <div className="story-text mb-48">
                                <p className="text-neutral-700 mb-24" style={{ 
                                    fontSize: 'clamp(16px, 3vw, 20px)', 
                                    lineHeight: '1.7',
                                    fontWeight: '400'
                                }}>
                                    Gümüş Pestil, nesilden nesile aktarılan bir aile geleneğinin ürünüdür. 
                                    Dedelerimizden öğrendiğimiz geleneksel yöntemlerle, doğanın en saf 
                                    malzemelerini kullanarak ürünlerimizi hazırlıyoruz.
                                </p>
                                <p className="text-neutral-700 mb-24" style={{ 
                                    fontSize: 'clamp(16px, 3vw, 20px)', 
                                    lineHeight: '1.7',
                                    fontWeight: '400'
                                }}>
                                    Her bir pestilimiz, el emeği göz nuruyla üretilir. Hiçbir katkı maddesi 
                                    kullanmadan, sadece doğal tatlandırıcılar ve meyvelerle, sağlıklı ve 
                                    lezzetli ürünler sunuyoruz. Amacımız, geleneksel lezzetleri modern 
                                    yaşamla buluşturmak ve sağlıklı beslenmeye katkıda bulunmak.
                                </p>
                                <p className="text-neutral-700 mb-0" style={{ 
                                    fontSize: 'clamp(16px, 3vw, 20px)', 
                                    lineHeight: '1.7',
                                    fontWeight: '500'
                                }}>
                                    Bugün, Türkiye'nin dört bir yanına ulaşan ürünlerimizle, binlerce ailenin 
                                    sofrasında yer almanın gururunu yaşıyoruz.
                                </p>
                            </div>

                            {/* Stats */}
                            <div className="row g-20 g-md-32 mb-48">
                                <div className="col-lg-4 col-md-4 col-12">
                                    <div className="stat-card rounded-24 bg-white shadow-lg hover-shadow-xl transition-3 h-100" 
                                         style={{ 
                                             padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                                             border: '1px solid rgba(41, 158, 96, 0.1)'
                                         }}>
                                        <div className="text-center">
                                            <div className="mb-16">
                                                <div className="d-inline-flex align-items-center justify-content-center w-60 h-60 rounded-circle bg-main-50 mb-12">
                                                    <i className="ph-fill ph-leaf text-main-600" style={{ fontSize: 'clamp(20px, 4vw, 28px)' }}></i>
                                                </div>
                                            </div>
                                            <h3 className="text-main-600 mb-12 fw-bold" style={{ fontSize: 'clamp(24px, 6vw, 36px)' }}>15+</h3>
                                            <p className="text-neutral-700 mb-0 fw-semibold" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>
                                                Farklı Çeşit
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-12">
                                    <div className="stat-card rounded-24 bg-white shadow-lg hover-shadow-xl transition-3 h-100" 
                                         style={{ 
                                             padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                                             border: '1px solid rgba(255, 193, 7, 0.1)'
                                         }}>
                                        <div className="text-center">
                                            <div className="mb-16">
                                                <div className="d-inline-flex align-items-center justify-content-center w-60 h-60 rounded-circle bg-warning-50 mb-12">
                                                    <i className="ph-fill ph-shield-check text-warning-600" style={{ fontSize: 'clamp(20px, 4vw, 28px)' }}></i>
                                                </div>
                                            </div>
                                            <h3 className="text-warning-600 mb-12 fw-bold" style={{ fontSize: 'clamp(24px, 6vw, 36px)' }}>%100</h3>
                                            <p className="text-neutral-700 mb-0 fw-semibold" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>
                                                Doğal Ürün
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-12">
                                    <div className="stat-card rounded-24 bg-white shadow-lg hover-shadow-xl transition-3 h-100" 
                                         style={{ 
                                             padding: 'clamp(1.5rem, 4vw, 2.5rem)',
                                             border: '1px solid rgba(40, 167, 69, 0.1)'
                                         }}>
                                        <div className="text-center">
                                            <div className="mb-16">
                                                <div className="d-inline-flex align-items-center justify-content-center w-60 h-60 rounded-circle bg-success-50 mb-12">
                                                    <i className="ph-fill ph-users text-success-600" style={{ fontSize: 'clamp(20px, 4vw, 28px)' }}></i>
                                                </div>
                                            </div>
                                            <h3 className="text-success-600 mb-12 fw-bold" style={{ fontSize: 'clamp(24px, 6vw, 36px)' }}>3</h3>
                                            <p className="text-neutral-700 mb-0 fw-semibold" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>
                                                Nesil Deneyim
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* CTA Button */}
                            <div className="d-flex flex-column flex-md-row gap-16 justify-content-center align-items-center">
                                <Link 
                                    to="/shop" 
                                    className="btn btn-main rounded-pill py-16 px-40 hover-bg-main-800 transition-3 shadow-lg"
                                    style={{ 
                                        fontSize: 'clamp(14px, 3vw, 16px)',
                                        fontWeight: '600',
                                        minWidth: '200px'
                                    }}
                                >
                                    Ürünleri İncele
                                    <i className="ph ph-arrow-right ms-12"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BrandStory

